export default __webpack_public_path__ + "static/abhinav-97b27912296e5ec648125d4aefc46677.png";